import { Box } from "@mui/material";
import "./css/Capacitaciones.css";
import { Grid } from "@material-ui/core";
import Capacitaciones from "./Capacitaciones";
import ModalConfirmFinishCourse from "./modals/ModalConfirmFinishCourse";
const CapacitacionesContent = () => {
  return (
    <>
      <div className="containerAdelantos">
        <Box mt={3} ml={5} className="Title" mb={2}>
          Cursos
        </Box>
        <div className="contenedor2">
          <Grid className="containerBodyCapacitaciones">
            <Capacitaciones />
            <ModalConfirmFinishCourse />
          </Grid>
        </div>
      </div>
    </>
  );
};

export default CapacitacionesContent;
